import card18 from './18.jpg';
import card19 from './19.jpg';
import card20 from './20.jpg';
import card21 from './21.jpg';
import card22 from './22.jpg';
import card57 from './57.jpg';
import card58 from './58.jpg';
import card59 from './59.jpg';
import card60 from './60.jpg';
import card61 from './61.jpg';
import card4 from './4.jpg';
import card5 from './5.jpg';
import card6 from './6.jpg';

const cards_data5 = [
    {
        image:card18,
    },
    {
        image:card19,
    },
    {
        image:card20,
    },
    {
        image:card21,
    },
    {
        image:card22,
    },
    {
        image:card57,
    },
    {
        image:card58,
    },
    {
        image:card59,
    },
    {
        image:card60,
    },
    {
        image:card61,
    },
    {
        image:card4,
    },
    {
        image:card5,
    },
    {
        image:card6,
    },
]

export default cards_data5;